"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._FilterAll = exports._FilterMappings = exports._FilterContractMappings = exports._FilterLeadMappings = exports._FilterCustomerMappings = exports.fitpayMappings = exports.mapMappings = exports._ContractCustomerMapping = exports._AllMappings = exports._TrialBookingMapping = exports._CustomerMapping = exports._Notes = exports._PaymentChoice = exports._BirthdayForm = exports._LeadMapping = exports._YondMapping = exports._DefaultMapping = exports._BankAccountMapping = exports._ContractMapping = exports._SimpleElementMapping = void 0;
var translation_1 = __importDefault(require("../services/translation"));
var input_mapping_presets_1 = require("./input.mapping.presets");
exports._SimpleElementMapping = {
    guardianWrapper: {
        legacy: { id: '#guardian-wrapper' },
        uid: 'guardianWrapper',
    },
};
exports._ContractMapping = {
    rateBundleStartDate: {
        legacy: { id: '#rateBundleStartDate', localStorage: 'startDate' },
        uid: 'contract.startDate',
        type: 'text',
    },
    rateBundleTermId: {
        legacy: { id: '#membershipId', localStorage: 'Memberships' },
        uid: 'contract.rateBundleTermId',
        required: true,
        type: 'text',
    },
    preuseDate: {
        legacy: { id: '#preuseDate', localStorage: 'preuseDate' },
        uid: 'contract.preuseDate',
        type: 'text',
    },
    rateBundleName: {
        legacy: { id: '#membershipNameInput', localStorage: 'membershipName' },
        uid: 'contract.rateBundleName',
        type: 'text',
    },
    rateBundlePrice: {
        legacy: { id: '#membershipPrice', localStorage: 'membershipPrice' },
        uid: 'contract.rateBundlePrice',
        type: 'text',
    },
    rateBundleTermValue: {
        legacy: { id: '#membershipMonth', localStorage: 'membershipMonth' },
        uid: 'contract.rateBundleTermValue',
        type: 'text',
    },
    rateBundleTermDuration: {
        legacy: { id: '#membershipMonth', localStorage: 'termDuration' },
        uid: 'contract.rateBundleTermDuration',
        type: 'text',
    },
    rateBundleAOV: {
        legacy: { id: '#aov', localStorage: 'aov' },
        uid: 'contract.aov',
        type: 'text',
    },
    isOnetimePayment: {
        legacy: { id: '#onetimePayment', localStorage: 'onetimePayment' },
        uid: 'onetimePayment',
    }
};
exports._BankAccountMapping = {
    iban: {
        legacy: { id: '#accountIban' },
        uid: 'customer.bankAccount.iban',
        required: true,
        regex: /^[A-Z]{2}[0-9]{2}(?:[ -]?[A-Z0-9]{1,4}){1,7}$/,
        regexError: translation_1.default.t('noValidIBAN'),
        type: 'text',
    },
    bic: {
        legacy: { id: '#BIC' },
        uid: 'customer.bankAccount.bic',
        ignoreValidationIfNotExisting: true,
        required: true,
        regex: /^[A-Z]{2}[0-9]{2}[A-Z0-9-\s]{0,30}$/,
        regexError: translation_1.default.t('noValidBic'),
        type: 'text',
    },
    consent: {
        legacy: { id: '#checkboxConsent', localStorage: 'sepa-consent' },
        uid: 'customer.bankAccount.consent',
        type: 'checkbox',
        required: true,
    },
    accountHolder: {
        legacy: { id: '#accountHolder' },
        uid: 'customer.bankAccount.accountHolder',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidBankAccountHolder'),
        type: 'text',
    },
};
exports._DefaultMapping = {
    studioId: {
        legacy: { id: '#locationId', localStorage: 'Location' },
        uid: 'studioId',
        required: true,
        type: 'text',
    },
    studioName: {
        legacy: { id: '#studioName', localStorage: 'StudioName' },
        uid: 'studioName',
        required: true,
        type: 'text',
    },
    referralCode: {
        legacy: { id: '#referralCode', localStorage: 'referralCode' },
        uid: 'customer.referralCode',
        type: 'text',
    },
    voucherCode: {
        legacy: { id: '#voucherCode', localStorage: 'voucherCode' },
        uid: 'voucherCode',
        type: 'text',
    },
    tenantId: {
        legacy: { id: '#TenantId', localStorage: 'TenantId' },
        uid: 'tenantId',
    },
};
exports._YondMapping = {
    studioOid: {
        legacy: { id: '#studioOid', localStorage: 'studioOid' },
        uid: 'studioOid',
    },
    legalEntityOid: {
        legacy: { id: '#legalEntityOid', localStorage: 'legalEntityOid' },
        uid: 'legalEntityOid',
    },
};
exports._LeadMapping = {
    firstname: {
        legacy: { id: '#firstName', id2: '#Vorname', localStorage: 'Vorname' },
        uid: 'customer.firstname',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidFirstname'),
        type: 'text',
    },
    lastname: {
        legacy: { id: '#lastName', id2: '#Nachname', localStorage: 'Nachname' },
        uid: 'customer.lastname',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidLastname'),
        type: 'text',
    },
    telephone_mobile: {
        legacy: {
            id: '#telefon',
            id2: '#telephone_mobile',
            localStorage: 'Telefon',
        },
        uid: 'customer.telephone_mobile',
        required: true,
        regex: /^(\d|\+)\d{4,}$/, //starting with digit or + with at least 5 digits 0-9
        regexError: translation_1.default.t('noValidPhoneNumber'),
        type: 'text',
    },
    email: {
        legacy: { id: '#email', localStorage: 'E-Mail' },
        uid: 'customer.email',
        required: true,
        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
        regexError: translation_1.default.t('noValidEmail'),
        type: 'text',
    },
    checkbox: {
        legacy: { id: '#Checkbox-Lead', localStorage: 'GDPR' },
        uid: 'customer.checkboxLead',
        required: true,
        type: 'checkbox',
    },
    gender: {
        legacy: {
            id: 'input[name="gender"]:checked',
            localStorage: 'Geschlecht',
        },
        uid: 'customer.gender',
        required: false,
        type: 'radio',
        ignoreValidationIfNotExisting: true,
        regex: /(MALE|FEMALE|UNISEX)/,
    },
};
exports._BirthdayForm = {
    age: {
        legacy: { id: '#age', localStorage: 'age' },
        uid: 'customer.age',
    },
    dateOfBirth: {
        legacy: { id: '#dateOfBirth', localStorage: 'birthday' },
        uid: 'customer.dateOfBirth',
        required: false,
        regex: /^\d{4}-\d{2}-\d{2}$/,
        regexError: translation_1.default.t('noValidBirthday'),
    },
    yearOfBirth: {
        legacy: { id: '#yearOfBirth', localStorage: 'yearOfBirth' },
        uid: 'customer.yearOfBirth',
        required: true,
        type: 'dropdown',
        regex: /^\d{4}$/,
        regexError: translation_1.default.t('noValidBirthdayYear'),
        hideSuccessMessage: true,
    },
    monthOfBirth: {
        legacy: { id: '#monthOfBirth', localStorage: 'monthOfBirth' },
        uid: 'customer.monthOfBirth',
        required: true,
        type: 'dropdown',
        regex: /^\d{1,2}$/,
        regexError: translation_1.default.t('noValidBirthdayMonth'),
        hideSuccessMessage: true,
    },
    dayOfBirth: {
        legacy: { id: '#dayOfBirth', localStorage: 'dayOfBirth' },
        uid: 'customer.dayOfBirth',
        required: true,
        type: 'dropdown',
        regex: /^\d{1,2}$/,
        regexError: translation_1.default.t('noValidBirthdayDay'),
        hideSuccessMessage: true,
    },
};
exports._PaymentChoice = {
    uid: 'customer.paymentChoice',
    type: 'dropdown',
    regex: /^(CASH|BANK_TRANSFER|DIRECT_DEBIT|CREDIT_CARD|TWINT)$/,
    required: true,
};
exports._Notes = {
    uid: 'contract.notes',
    type: 'text',
};
exports._CustomerMapping = __assign(__assign({}, exports._BankAccountMapping), { countryCode: {
        legacy: { id: '#countryCode', localStorage: 'countryCode' },
        uid: 'customer.countryCode',
        defaultValue: 'DE',
        required: true,
        type: 'text',
    }, gender: {
        legacy: {
            id: 'input[name="gender"]:checked',
            localStorage: 'Geschlecht',
        },
        uid: 'customer.gender',
        required: true,
        type: 'radio',
        regex: /(MALE|FEMALE|UNISEX)/,
    }, guardian: {
        legacy: { id: '#guardian' },
        uid: 'customer.guardian',
        required: true,
        type: 'text',
    }, phonePrefix: {
        legacy: { id: '#phonePrefix', localStorage: 'phonePrefix' },
        uid: 'customer.phonePrefix',
        type: 'text',
    }, zipCode: {
        legacy: { id: '#zipCode' },
        uid: 'customer.zipCode',
        required: true,
        regex: /^\d{3,7}$/,
        regexError: translation_1.default.t('noValidZIP'),
        type: 'text',
    }, houseNumber: {
        legacy: { id: '#houseNumber' },
        uid: 'customer.houseNumber',
        required: true,
        regex: /^.+$/,
        regexError: translation_1.default.t('noValidHousenumber'),
        type: 'text',
    }, city: {
        legacy: { id: '#localCity' },
        uid: 'customer.city',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidCity'),
        type: 'text',
    }, street: {
        legacy: { id: '#streetAdress' },
        uid: 'customer.street',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidStreetName'),
        type: 'text',
    } });
exports._TrialBookingMapping = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.firstname)), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.lastname)), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.gender)), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.telephone_mobile)), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.email, { required: false })), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.dateOfBirth)), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.street, { ignoreValidationIfNotExisting: true })), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.houseNumber, { ignoreValidationIfNotExisting: true })), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.zip, { ignoreValidationIfNotExisting: true })), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.city, { ignoreValidationIfNotExisting: true })), (0, input_mapping_presets_1.getInputMapping)(input_mapping_presets_1.inputMappingParam.country, { ignoreValidationIfNotExisting: true }));
exports._AllMappings = __assign(__assign(__assign(__assign({}, exports._LeadMapping), exports._CustomerMapping), exports._DefaultMapping), exports._ContractMapping);
exports._ContractCustomerMapping = {
    studioId: exports._DefaultMapping,
    contract: exports._ContractMapping,
    customer: __assign(__assign({}, exports._LeadMapping), exports._CustomerMapping),
};
exports.mapMappings = {
    customer: [],
};
exports.fitpayMappings = {
    stripeCustomerId: {
        legacy: { id: '#stripeCustomerId' },
        uid: 'stripeCustomerId',
        required: false,
        type: 'text',
    },
};
// {
//   studioId: number;
//   referralId?: number;
//   contract: IContract;
//   customer: ICustomer;
//   voucherCode?: string;
// }
/**
 * These arrays are used to filter the current required fields.
 */
exports._FilterCustomerMappings = Object.keys(exports._CustomerMapping);
exports._FilterLeadMappings = Object.keys(exports._LeadMapping);
exports._FilterContractMappings = Object.keys(exports._ContractMapping);
exports._FilterMappings = Object.keys(exports._DefaultMapping);
exports._FilterAll = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], exports._FilterCustomerMappings, true), exports._FilterLeadMappings, true), exports._FilterContractMappings, true), exports._FilterMappings, true);
